'use client';
var classes = {"indicator":"m_5e5256ee","icon":"m_1b1c543a","indicator--outline":"m_76e20374"};

export { classes as default };
//# sourceMappingURL=CheckboxIndicator.module.css.mjs.map
